import {
    ShopperCustomersMutations,
    useCustomerId,
    useCustomerProductLists,
    useShopperCustomersMutation
} from '@salesforce/commerce-sdk-react'
import {useMutation} from '@tanstack/react-query'

const LIST_NAME = 'notifyWhenInStock'
const LIST_TYPE = 'custom_1'

export const useProductNotification = () => {
    const customerId = useCustomerId()

    return useCustomerProductLists(
        {
            parameters: {customerId}
        },
        {enabled: !!customerId}
    )
}

export const useCreateProductNotificationMutation = () => {
    const customerId = useCustomerId()

    const {data: lists} = useProductNotification()

    const {mutateAsync: createList} = useShopperCustomersMutation(
        ShopperCustomersMutations.CreateCustomerProductList
    )
    const createCustomerProductList = () =>
        createList({
            body: {name: LIST_NAME, type: LIST_TYPE, event: {type: LIST_NAME}},
            parameters: {customerId}
        })

    const {mutateAsync: createCustomerProductListItem} = useShopperCustomersMutation(
        ShopperCustomersMutations.CreateCustomerProductListItem
    )

    return useMutation({
        mutationFn: async ({product, data}) => {
            const existingList = lists?.data?.find(
                (list) => list.name === LIST_NAME && list?.event?.type === LIST_NAME
            )

            const list = existingList || (await createCustomerProductList())

            const isItemInList = list?.customerProductListItems?.find(
                (i) => i.productId === product?.id
            )
            if (!isItemInList) {
                await createCustomerProductListItem({
                    parameters: {
                        listId: list.id,
                        customerId
                    },
                    body: {
                        quantity: 1,
                        productId: product.id,
                        public: false,
                        priority: 1,
                        type: 'product',
                        c_notifyFirstName: data?.firstName,
                        c_notifyLastName: data?.lastName,
                        c_notifyEmail: data?.email,
                        c_notifyPhone: data?.phone
                    }
                })
            }
        }
    })
}
